import React, { useContext } from "react";
import { styled } from '@mui/system';

import { Button } from 'primereact/button';

import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import { PrimeIcons } from 'primereact/api';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; // theme
import 'primereact/resources/primereact.css';

import "../../styles/theme/aistheme.css";
import "../../styles/theme/sharedThemeOverride.css";
import { MainViewInstruction, changeMainView } from "../../globals/observables/main/mainViewObservable";
import { MenuBlocksContext } from "../../globals/context/menuBlocksContext";
import { MenuBlockItemCollection } from "../../globals/data/menuData/menuData";
import MenuDisplayBlock from "./blocks/menuDisplayBlock";



const GeneralButtonStyle = {
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    color: "black",
    height: "35px",
    marginTop: "auto",
    marginBottom: "auto",
    width: "35px",
    backgroundColor: "gray",
    maxHeight: "35px !Important",
    maxWidth: "35px  !Important",
    minHeight: "35px !Important",
    minWidth: "35px  !Important",
    padding: "0px"
  };
  
  
  const WrapperContainer = styled("div")(
    ({ theme }) => `
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    background-color: #595959;
    flex-basis: 100%;

    margin:20px;
    `
  );


  
  const ItemsContainer = styled("div")(
    ({ theme }) => `
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background-color: lightblue;

    overflow-y:scroll;
    `
  );


  const BodyContainer = styled("div")(
    ({ theme }) => `
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    background-color: lightgreen;

    
    
    `
  );


  
  const MenuContainer = styled("div")(
    ({ theme }) => `
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background-color: lightgray;

    
    min-width:100px;
    max-width:300px;

    // margin-left:auto;
    // margin-right:auto;
    // margin-top:auto;
    // margin-bottom:auto;
    
    `
  );

  
  
  const PresenterContainer = styled("div")(
    ({ theme }) => `
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background-color: crimson;

    
    // min-height:100px;

    // margin-left:auto;
    // margin-right:auto;
    // margin-top:auto;
    // margin-bottom:auto;
    
    `
  );



  
  



interface HeaderProps{

}


function MenuPresenter(props:HeaderProps){


    //NOTES:
    //Ok - very V1 effort here.
    //We take a collection of menu blocks and stack them on top of each other
    //In future versions, we want these blocks to be determined by the role of the user
    //i.e. accounting wont be accessible to everyone, only devs should see errors etc


    const menuBlocksContext = useContext<MenuBlockItemCollection>(MenuBlocksContext);


    return (
        <WrapperContainer id="auth presenter WrapperContainer">            
           <ItemsContainer id="ItemsContainer">


            {
                (menuBlocksContext !== undefined && menuBlocksContext.blocks !== undefined )&&
                (menuBlocksContext.blocks.map((item,index)=>{
                    return(
                        <MenuDisplayBlock
                            key={index}
                            menuBlockItem={item}
                        />
                    )
                }))
            }

           </ItemsContainer>
        </WrapperContainer>
        
    )
}


export default MenuPresenter;